import { formatNumber } from './helper.js';
import { RATE_PLAN } from '../constants/common';
import insightsRatePlansApiBody from '../mockApis/insightsRatePlans';

export const prepareRatePlanData = (comparedRates) => {
  let ratePlanData = [];
  let maxCandidateCount = 0;
  if(comparedRates && comparedRates.length) {
    for (let i = 0 ; i < comparedRates.length; i++ ) {
      let rateCandidates = [];
      let rateCandidateRequirements = comparedRates[i].resources.rateCandidateRequirements;
      let resources = comparedRates[i].resources;

      comparedRates[i].totalCost = formatNumber(comparedRates[i].totalCost);
      comparedRates[i]['isPositiveSaving'] = comparedRates[i].savings > 0;
      comparedRates[i]['savingCost'] = Math.abs(comparedRates[i].savings);
      comparedRates[i]['planTitle'] = (comparedRates[i].isCurrentRate ? 'RATEPLANS.PLAN_BTN_TEXT_CURRENT' : (comparedRates[i].isHighestSavings ? 'RATEPLANS.PLAN_HIGHEST' : ''));
      if(resources.planName && resources.description) {
        if(comparedRates[i].isCurrentRate) {
          ratePlanData.unshift(comparedRates[i]);
        } else {
          ratePlanData.push(comparedRates[i]);
        }
      }

      if(rateCandidateRequirements && rateCandidateRequirements.length) {
        if(rateCandidateRequirements.length && maxCandidateCount < rateCandidateRequirements.length) {
          maxCandidateCount = rateCandidateRequirements.length;
        }

        for(let j=0; j < rateCandidateRequirements.length; j++) {
          if(rateCandidateRequirements[j].type == RATE_PLAN.NEGATIVE ) {
            rateCandidates.push(rateCandidateRequirements[j]);
          } else {
            rateCandidates.unshift(rateCandidateRequirements[j]);
          }
        }
        comparedRates[i].resources.rateCandidateRequirements = rateCandidates;
      }
    }
  }
  return {ratePlanData: ratePlanData, minHeightCandidate: maxCandidateCount};
};

export const getMissingMockApiData = () => {
  let ratePlanData = prepareRatePlanData(insightsRatePlansApiBody.payload.comparedRates);
  return ratePlanData;
};